if (!customElements.get("collection-spotlight")) {
  class CollectionSpotlight extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        this._handleSectionLoad = (event) => {
          const loadedId = event.detail?.sectionId;
          const matches =
            loadedId != null
              ? String(loadedId) === String(this.dataset.sectionId)
              : event.target?.contains?.(this);

          if (!matches || !this.isConnected) return;

          this.init();
        };

        document.addEventListener(
          "shopify:section:load",
          this._handleSectionLoad,
        );
      }

      this.init();
    }

    disconnectedCallback() {
      if (this._handleSectionLoad) {
        document.removeEventListener(
          "shopify:section:load",
          this._handleSectionLoad,
        );
      }

      this._cspAbort?.abort();
    }

    init() {
      this._cspAbort?.abort();
      this._cspAbort = new AbortController();

      const defaultActive = this.dataset.defaultActive || "1";
      const initialSlide = this.querySelector(
        `.collection-spotlight__image[data-slide-image="${defaultActive}"]`,
      );

      this._currentSlideHasImage = initialSlide != null && initialSlide.hasAttribute("data-has-image");

      this._activate(defaultActive);
      this._bind(this._cspAbort.signal);
    }

    /* --------------- *** Activation *** --------------- */

    _activate(index) {
      const id = String(index);
      const imagesContainer = this.querySelector(".collection-spotlight__images");
      const defaultImage = this.querySelector(".collection-spotlight__image--default");
      const incoming = this.querySelector(
        `.collection-spotlight__image[data-slide-image="${id}"]`,
      );

      const previousHadImage = this._currentSlideHasImage ?? false;
      const incomingHasImage = incoming != null && incoming.hasAttribute("data-has-image");
      const shouldShowDefault = incoming != null && !incomingHasImage;

      if (defaultImage) {
        const shouldFade = previousHadImage && shouldShowDefault;

        defaultImage.classList.toggle("collection-spotlight__image--fade-in", shouldFade);
      }

      this.querySelectorAll(".collection-spotlight__image[data-slide-image]").forEach((el) => {
        el.classList.toggle(
          "collection-spotlight__image--active",
          el.getAttribute("data-slide-image") === id,
        );
      });

      imagesContainer?.classList.toggle(
        "collection-spotlight__images--show-default",
        shouldShowDefault,
      );

      this.querySelectorAll(".collection-spotlight__icon").forEach((el) => {
        el.classList.toggle(
          "collection-spotlight__icon--active",
          el.getAttribute("data-slide-index") === id,
        );
      });

      this.querySelectorAll(".collection-spotlight__text-slide").forEach((el) => {
        el.classList.toggle(
          "collection-spotlight__text-slide--active",
          el.getAttribute("data-slide-text") === id,
        );
      });

      this._currentSlideHasImage = incomingHasImage;
    }

    /* --------------- *** Event Binding *** --------------- */

    _bind(signal) {
      const icons = this.querySelectorAll(".collection-spotlight__icon");

      icons.forEach((icon) => {
        icon.addEventListener(
          "mouseenter",
          () => {
            const index = icon.getAttribute("data-slide-index");

            if (index) this._activate(index);
          },
          { signal },
        );

        icon.addEventListener(
          "click",
          () => {
            const index = icon.getAttribute("data-slide-index");

            if (index) this._activate(index);
          },
          { signal },
        );

        icon.addEventListener(
          "focus",
          () => {
            const index = icon.getAttribute("data-slide-index");

            if (index) this._activate(index);
          },
          { signal },
        );
      });
    }
  }

  customElements.define("collection-spotlight", CollectionSpotlight);
}
